import { Col, Row } from "react-bootstrap";
import { CommonModal } from "../Input";
import DetailField from "../Customers/CustomerDetails/DetailField";

const SectionContainer = ({ title, children }) => (
  <div className="mb-4 ">
    <h6 className="fw-bold mb-2 fs-14 text-black">{title}</h6>
    <div className=" rounded-2 p-4 bg-body">
      <Row className="gy-3">{children}</Row>
    </div>
  </div>
);

const BeneficiaryDetailsModal = ({ show, onHide, beneficiary }) => {
  if (!beneficiary) return null;

  return (
    <CommonModal
      show={show}
      onHide={onHide}
      size="xl"
      title={
        <div>
          <h4 className="fw-bold text-black mb-1">Beneficiary details</h4>
          <p className="fs-13 text-muted mb-0 fw-normal">
            View the beneficiary information
          </p>
        </div>
      }
      className="modal-premium "
      modalProps={{ centered: true }}
      footer={null}
    >
      <div className="px-1">
        <SectionContainer title="Basic information">
          <Col md={2} sm={4} xs={6}>
            <DetailField label="Country" value={beneficiary.country} />
          </Col>
          <Col md={3} sm={4} xs={6}>
            <DetailField label="Currency" value={beneficiary.currency} />
          </Col>
          <Col md={2} sm={4} xs={6}>
            <DetailField
              label="Receiver type"
              value={beneficiary.receiverType}
            />
          </Col>
          <Col md={2} sm={4} xs={6}>
            <DetailField
              label="Receiving method"
              value={beneficiary.receivingMethod}
            />
          </Col>
          <Col md={3} sm={4} xs={6}>
            <DetailField
              label="Relationship to sender"
              value={beneficiary.relationship}
            />
          </Col>
        </SectionContainer>

        <SectionContainer title="ID information">
          <Col md={2} sm={4} xs={6}>
            <DetailField label="ID type" value={beneficiary.idType} />
          </Col>
          <Col md={3} sm={4} xs={6}>
            <DetailField label="ID number" value={beneficiary.idNumber} />
          </Col>
          <Col md={2} sm={4} xs={6}>
            <DetailField
              label="ID Expiry Date"
              value={beneficiary.idExpiryDate}
            />
          </Col>
          <Col md={2} sm={4} xs={6}>
            <DetailField label="Date of birth" value={beneficiary.dob} />
          </Col>
          <Col md={3} sm={4} xs={6}></Col>
        </SectionContainer>

        <SectionContainer title="Personal information">
          <Col md={4} sm={6}>
            <DetailField label="First name" value={beneficiary.firstName} />
          </Col>
          <Col md={4} sm={6}>
            <DetailField
              label="Middle initial"
              value={beneficiary.middleInitial}
            />
          </Col>
          <Col md={4} sm={6}>
            <DetailField
              label="Tax identification number"
              value={beneficiary.taxId}
            />
          </Col>
        </SectionContainer>

        <SectionContainer title="Contact information">
          <Col md={12}>
            <DetailField
              label="Contact number"
              value={
                beneficiary.contactNumber ||
                beneficiary.phone ||
                beneficiary.contactNo
              }
            />
          </Col>
        </SectionContainer>

        <SectionContainer title="Address information">
          <Col md={4} sm={6}>
            <DetailField label="Address" value={beneficiary.address} />
          </Col>
          <Col md={4} sm={6}>
            <DetailField label="City" value={beneficiary.city} />
          </Col>
          <Col md={4} sm={6}>
            <DetailField label="State" value={beneficiary.state} />
          </Col>
        </SectionContainer>

        <SectionContainer title="Account details">
          <Col md={4} sm={6}>
            <DetailField label="Bank" value={beneficiary.bank} />
          </Col>
          <Col md={4} sm={6}>
            <DetailField
              label="Account number"
              value={beneficiary.accountNumber}
            />
          </Col>
          <Col md={4} sm={6}>
            <DetailField label="SWIFT code" value={beneficiary.swiftCode} />
          </Col>
        </SectionContainer>
      </div>
    </CommonModal>
  );
};

export default BeneficiaryDetailsModal;
